import styled from '@emotion/styled/macro'

import { flexCenter, pageContentDefaultSize } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'
import {
  ContentNotAvailableIconContainer,
  ContentNotAvailableText
} from 'components/atoms/ContentNotAvailable/styles'

const DocumentsFolderContainer = styled('section')`
  ${pageContentDefaultSize}

  color: var(--CINight);
  margin-top: 48px;

  ${mediaQuery('tablet')} {
    margin-top: 24px;
  }

  > h2 {
    margin-bottom: 8px;
  }

  > p {
    margin: 0;
  }
`

const DocumentListEmptyContainer = styled('section')`
  margin-bottom: 2rem;
  margin-top: 48px;
  ${ContentNotAvailableText} {
    color: var(--slate-60);
    text-align: center;
  }
`

const DocumentsFolderList = styled('ul')`
  margin-bottom: 32px;
  margin-top: 24px;
  padding: 0;
`

const DocumentsFolderListItem = styled('li')`
  align-items: center;
  background-color: var(--london-fog);
  border-left: 1px solid var(--gray-2);
  border-right: 1px solid var(--gray-2);
  border-top: 1px solid var(--gray-2);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  list-style: none;
  padding: 8px;

  :last-of-type {
    border-bottom: 1px solid var(--gray-2);
  }

  .mdi {
    font-size: 1.8rem;
  }

  .green {
    color: var(--success);
  }

  .yellow {
    color: var(--warning);
  }

  .red {
    color: var(--danger-2);
  }
`

const DocumentsFolderListItemIcon = styled('div')`
  align-self: flex-start;
  display: flex;
  margin-right: 8px;
  margin-top: -5px;
`

const DocumentsFolderListItemContent = styled('div')`
  flex: 1;
  min-width: 0;

  > p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    display: block;
    font-size: 0.8rem;
    text-transform: capitalize;

    &:first-of-type {
      color: var(--gray-1);
    }
  }

  p {
    font-size: 1rem;
    font-weight: 500;
    margin: 0;
  }
`

const DocumentsFolderBtnContainer = styled('div')`
  ${flexCenter}

  height: auto;

  > button {
    width: inherit;

    ${mediaQuery('tablet', 'mobile')} {
      max-width: 266px;
    }

    ${mediaQuery('', 'tablet')} {
      max-width: 380px;
    }
  }
`

const DocumentsFolderCertificateContainer = styled('div')`
  margin-bottom: 48px;

  > p {
    margin-bottom: 48px;
  }

  ${ContentNotAvailableIconContainer} {
    margin-bottom: 16px;
  }

  ${ContentNotAvailableText} {
    color: var(--slate-60);
    text-align: center;
  }
`

export {
  DocumentsFolderBtnContainer,
  DocumentsFolderCertificateContainer,
  DocumentsFolderContainer,
  DocumentListEmptyContainer,
  DocumentsFolderList,
  DocumentsFolderListItem,
  DocumentsFolderListItemContent,
  DocumentsFolderListItemIcon
}
